import { useQuery } from '@tanstack/react-query'

import { PaginationMetadata } from '../../DomainPresentation/utils'
import { request } from '../../../lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'
import { PaginationParams } from '../../../types/pagination'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { AccountId } from '../models'

export const getFacebookAdAccounts = async (
  accountId: number,
  connectionId: number,
  pagination?: PaginationParams
): Promise<
  { adAccounts: AccountId[]; metadata?: PaginationMetadata; selected?: number[] } | Error
> => {
  return await request<{ adAccounts: AccountId[] }>({
    url: `/accounts/${accountId}/facebook/${connectionId}/ad-accounts`,
    method: 'GET',
    params: pagination,
  })
}

type QueryFnType = typeof getFacebookAdAccounts

export const useGetFacebookAdAccounts = ({
  connectionId,
  config,
  pagination,
}: {
  connectionId: number
  config?: QueryConfig<QueryFnType>
  pagination?: PaginationParams
}) => {
  const { accountId } = useUserStore()
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [
      'facebookAdAccounts',
      connectionId,
      pagination?.page,
      pagination?.limit,
      pagination?.search,
      pagination?.sort,
    ],
    queryFn: () => getFacebookAdAccounts(accountId, connectionId, pagination),
    staleTime: 0,
    ...config,
  })
}
